import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class AccountingProcessingService {
    constructor(private datatask: DataTaskService) {}
    /**
     * Retrieves page get for accountingprocessing.
     *
     * @datatask 1672
     * @datataskName sp_ws_p2_w_accountingprocessing_get
     * @param params the current custact_no, provide a custact_no of '0' if none.
     * @returns promise containing page get for accounting processing.
     */
    public async getAccountingProcessing(params: GetAccountingProcessingParams): Promise<AccountingProcessingGet> {
        return (await this.datatask.Post(1672, params))[0];
    }

    /**
     * Retrieves list of accounting processing functions.
     *
     * @datatask 1673
     * @datataskName sp_ws_p2_w_accountingprocessing_functions
     * @returns promise containing list of accounting processing functions.
     */
    public getAccountingProcessingFunctions(): Promise<AccountingProcessingFunctionItem[]> {
        return this.datatask.Post(1673);
    }

    /**
     * Retrieves list of accounting processing items.
     *
     * @datatask 1674
     * @datataskName sp_ws_p2_w_accountingprocessing_custact_list
     * @param params settings for the list to retrieve.
     * @returns promise containing list of accounting processing functions.
     */
    public getAccountingProcessings(params: GetAccountingProcessingsParams): Promise<AccountingProcessingItem[]> {
        return this.datatask.Post(1674, params);
    }
}

export interface AccountingProcessingFunctionItem {
    accountingfunction_id: string;
    accountingfunction_name: string;
    orderby: string;
}

export interface GetAccountingProcessingParams {
    custact_no: string | number;
}

export interface AccountingProcessingGet {
    custact_no: string;
    businessco_no: string;
    accountingfunction: string;
    searchtext: string;
    custact_no_active: string;
    show_accountingfunction: '1' | '0';
    show_purchase_match: '1' | '0';
    docarc_keyno: string;
    grid_view_id: string;
    show_ts_head: '1' | '0';
    bg_main: string;
}

export interface GetAccountingProcessingsParams {
    custact_no: string;
    businessco_no: string;
    accountingfunction: string;
}

export interface AccountingProcessingItem {
    item_id: string;
    item_name: string;
    item_name_sub1: string;
    item_state: string;
    item_parms: string;
    item_path: string;
    orderby: string;
    item_glyphicon: string;
    item_glyphicon_color: string;
    item_filtervalue: string;
}
